import axios from "axios";

type HTTP_METHODS = "get" | "post" | "put" | "delete" | "patch";


const DEFAULT_API_PATH = process.env.REACT_APP_BASE_API_URL; 


class BaseApiService {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor(props?: any) {}
  getDefaultApiUrl() {
    return DEFAULT_API_PATH;
  }

  getAxios() {
    return axios;
  }

  makePostRequestWithoutAuth(
    url: string,
    body?: any,
    headers?: any,
    responseType?: any
  ) {
    url = `${DEFAULT_API_PATH}${url}`;

    const headersObj = {
      headers: {
        "Content-Type": "application/json",
        ...(headers || {}),
      },
      ...(responseType ? { responseType: responseType } : {}),
    };

    return axios.post(url, body, headersObj);
  }
}

export default BaseApiService;
